import { NgModule } from '@angular/core';
import { PersistenceService } from '../services/persistence.service';
/**
 * The module for the persistence framework.  This will register the PersistenceService
 * as a provider and export it.
 * 
 * @export
 * \@class AngularPersistenceModule
 * 
 * @author Scott O'Bryan
 * \@since 1.0
 */
export class PersistenceModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    providers: [PersistenceService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PersistenceModule_tsickle_Closure_declarations() {
/** @type {?} */
PersistenceModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PersistenceModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
